import { type TFunction } from 'i18next';

export const getErrorMessage = (t: TFunction, formState?: { message?: string }) => {
  if (formState?.message) {
    return t(formState.message);
  }

  return undefined;
};
